/**
 * Cmd/Ctrl + K palette. Toggle with the shortcut, dismiss with Escape,
 * backdrop click, or selecting any item.
 */
export function initCommandPalette({
  paletteId = 'cmd-palette',
  inputId = 'cmd-input',
} = {}) {
  const palette = document.getElementById(paletteId);
  const input = document.getElementById(inputId);
  if (!palette || !input) return;

  const open = () => {
    palette.classList.add('open');
    requestAnimationFrame(() => input.focus());
  };
  const close = () => palette.classList.remove('open');

  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      palette.classList.contains('open') ? close() : open();
      return;
    }
    if (e.key === 'Escape' && palette.classList.contains('open')) {
      close();
    }
  });

  palette.addEventListener('click', (e) => {
    if (e.target === palette) close();
  });

  palette.querySelectorAll('.cmd-item').forEach((item) => {
    item.addEventListener('click', close);
  });
}
